import React, { Fragment } from "react"
import { sizes } from "../Theme"
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export class Above extends React.Component {
    state = {
        visible: false
    }

    componentDidMount() {
        this.checkCondition()
        window.addEventListener("resize", this.checkCondition)
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.checkCondition)
    }

    checkCondition = () => {
        const size = Number.isInteger(this.props.size)
            ? this.props.size
            : sizes[this.props.size]
        if (size < window.innerWidth) {
            this.setState({ visible: true })
        } else {
            this.setState({ visible: false })
        }
    }

    render() {
        return this.state.visible ? (
            <Fragment>{this.props.children}</Fragment>
        ) : null
    }
}

export class Below extends React.Component {
    state = {
        visible: false
    }

    componentDidMount() {
        this.checkCondition()
        window.addEventListener("resize", this.checkCondition)
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.checkCondition)
    }

    checkCondition = () => {
        const size = Number.isInteger(this.props.size)
            ? this.props.size
            : sizes[this.props.size]

        if (size >= window.innerWidth) {
            this.setState({ visible: true })
        } else {
            this.setState({ visible: false })
        }
    }

    render() {
        return this.state.visible ? (
            <Fragment>{this.props.children}</Fragment>
        ) : null
    }
}

// Refactored ScrollToTop to use hooks
function ScrollToTop({ children }) {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]); // Dependency on pathname triggers effect on change

    return children; // Render the children directly
}

// Remove withRouter export, export ScrollToTop directly
export default ScrollToTop;
